module.exports = __webpack_public_path__ + "img/bg_ty_sj.90351d2c.png";